/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Ocop_Year_InvalidInputs */

const vi_error_shop_ocop_year_invalid = /** @type {(inputs: Error_Shop_Ocop_Year_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Năm chứng nhận OCOP từ 2015 đến 2100.`)
};

/**

* @param {Error_Shop_Ocop_Year_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_ocop_year_invalid = /** @type {((inputs?: Error_Shop_Ocop_Year_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Ocop_Year_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_ocop_year_invalid(inputs)
});